/* istanbul ignore file */
import { ComposedTheme } from '@glu/theming';

export default ({ palette, typography }: ComposedTheme) => ({
  indicator: {
    backgroundColor: palette.primary.normal,
    height: 4,
    transitionDuration: 300,
    transition: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  tab: {
    color: palette.text.dark,
    font: 'inherit',
    selectedColor: palette.primary.normal,
    focusColor: palette.focus.normal,
  },
  tabAddition: {
    textTransform: 'none',
    font: typography.fontFamily,
    fontSize: 16,
    fontWeight: typography.fontWeightHeavy,
  },
  tabDark: {
    color: palette.text.light,
    darkFocusColor: palette.focus.dark,
  },
  wrapBorder: {
    borderBottom: `1px solid ${palette.grey.G300}`,
  },
  darkFocusColor: palette.focus.dark,
  focusColor: palette.focus.normal,
  styledTab: {
    backgroundColor: palette.grey.G100,
    fontFamily: `"Roboto Condensed", ${typography.fontFamily}`,
    borderBottomColor: `${palette.grey.G400}!important`,
  },
  defaultTabBorderColor: palette.grey.G400,
  // Broken, solid should be removed and only a color should be applied - in GLU-7492
  defaultTabBorder: `solid ${palette.grey.G400}`,
  badge: {
    backgroundColor: palette.grey.G200,
    color: palette.text.dark,
    padding: 5,
    minWidth: 25,
    borderRadius: 20,
    display: 'block',
    fontSize: 12,
    fontWeight: 'bold',
  },
});
